/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { v4 as uuidv4 } from 'uuid';
import { COMPONENT_QUERY_DEFAULT_PARAMS, COMPONENT_QUERY_PARAMS } from './NavigationConstants';

const queryString = require('query-string');

class QueryService {
  get page() {
    const q = this.parseQuery();
    return Math.abs(Number(q[COMPONENT_QUERY_PARAMS.PAGE])) || COMPONENT_QUERY_DEFAULT_PARAMS.PAGE;
  }

  get pageSize() {
    const q = this.parseQuery();
    return Math.abs(Number(q[COMPONENT_QUERY_PARAMS.SIZE])) || COMPONENT_QUERY_DEFAULT_PARAMS.SIZE;
  }

  get sort() {
    const q = this.parseQuery();
    return q[COMPONENT_QUERY_PARAMS.SORT] || COMPONENT_QUERY_DEFAULT_PARAMS.SORT;
  }

  get filter() {
    const q = this.parseQuery();
    const encodedFilter = q[COMPONENT_QUERY_PARAMS.FILTER];
    if (encodedFilter?.length > 0) {
      return encodedFilter.split(',').map((data) => {
        const _filter = data.split('|');
        return {
          id: uuidv4(),
          type: _filter[0],
          value: _filter[1],
        };
      });
    }
    return COMPONENT_QUERY_DEFAULT_PARAMS.FILTER;
  }

  stringify = (object, props = {}) => {
    return queryString.stringify(object, props);
  };

  parseSorting = (object) => {
    const parsedObject = object?.split(',');
    return parsedObject
      ? {
        sortColumn: parsedObject[0],
        sortOrder: parsedObject[1],
      }
      : null;
  };

  parseQuery = () => {
    return queryString.parse(window.location?.search);
  };
}

export default QueryService;
